import { Color } from '@tiptap/extension-color'
import Link from '@tiptap/extension-link'
import Placeholder from '@tiptap/extension-placeholder'
import TextStyle from '@tiptap/extension-text-style'
import StarterKit from '@tiptap/starter-kit'
import { Extensions } from '@tiptap/react'
import { ImageWithKey } from './imageWithKey'
import { Pdf } from './pdfNode'
import { Video } from './videoNode'

/**
 * Single source of truth for the TipTap extension set so the editor and the
 * read-only renderer interpret stored documents identically.
 */
export const buildDocExtensions = (placeholder?: string): Extensions => {
  const extensions: Extensions = [
    StarterKit,
    TextStyle,
    Color,
    Link.configure({ openOnClick: true, autolink: true, HTMLAttributes: { rel: 'noopener noreferrer' } }),
    ImageWithKey,
    Video,
    Pdf,
  ]
  if (placeholder) {
    extensions.push(Placeholder.configure({ placeholder }))
  }
  return extensions
}
